import React, { useCallback, useState } from 'react';
import { Redirect, Route, Switch, useHistory } from 'react-router-dom';
import { generateTaxablePeriods } from '../common/util-fun';
import * as cs from '../components/common/common-styles';
import {
  DEFAULT_FORM_VALUE,
  TBID_FORM_KEYS,
} from '../components/common/constants';
import {
  BusinessIdInput,
  GrossRevenueForm,
  PaymentForm,
  Success,
  TbidConfirmation,
  TbidContact
} from '../tbid';
import { MidFlowRoute } from './mid-flow-route';

const earliestReportablePeriod = new Date('07/01/2021');
const { taxablePeriods: taxablePeriodsInit } = generateTaxablePeriods({ earliestReportablePeriod });

function Routes() {
  const [enteredFlow, setEnteredFlow] = useState(false);

  const [payload, setPayload] = useState({});
  const [businessInfo, setBusinessInfo] = useState();
  const [licenseFeeInfo, setLicenseFeeInfo] = useState();
  const [paymentData, setPaymentData] = useState();

  const [taxablePeriods, setTaxablePeriods] = useState(taxablePeriodsInit);

  // Used to remember what the user entered for their first and last name in the contact form
  const [ownerFirstName, setOwnerFirstName] = useState(DEFAULT_FORM_VALUE);
  const [ownerLastName, setOwnerLastName] = useState(DEFAULT_FORM_VALUE);

  const history = useHistory();
  window.hh = history;

  const handleNameChange = useCallback((e) => {
    if (e.target.name === TBID_FORM_KEYS.ownerFirstName) setOwnerFirstName(e.target.value);
    else setOwnerLastName(e.target.value);
  }, [ownerFirstName, ownerLastName, setOwnerFirstName, setOwnerLastName]);

  const updatePayload = useCallback((data) => {
    setPayload(payload => ({ ...payload, ...data }));
  }, [setPayload]);

  const resetFlow = useCallback(() => {
    setEnteredFlow(false);
    setBusinessInfo(null);
    setOwnerFirstName(DEFAULT_FORM_VALUE);
    setOwnerLastName(DEFAULT_FORM_VALUE);
    setPayload({});
    setTaxablePeriods(taxablePeriodsInit);
  }, []);

  return (
    <cs.ViewContainer>
      <Switch>
        <Route exact path="/">
          <Redirect to="/business-id" />
        </Route>

        <Route path="/business-id">
          <BusinessIdInput
            reset={resetFlow}
            setEnteredFlow={setEnteredFlow}
            businessInfo={businessInfo}
            setBusinessInfo={setBusinessInfo}
            setLicenseFeeInfo={setLicenseFeeInfo}
          />
        </Route>

        <MidFlowRoute enteredFlow={enteredFlow} path="/revenue">
          <GrossRevenueForm
            businessInfo={businessInfo}
            setLicenseFeeInfo={setLicenseFeeInfo}
            taxablePeriods={taxablePeriods}
            setTaxablePeriods={setTaxablePeriods}
          />
        </MidFlowRoute>

        <MidFlowRoute enteredFlow={enteredFlow} path="/confirmation">
          <TbidConfirmation
            payload={payload}
            updatePayload={updatePayload}
            businessInfo={businessInfo}
            licenseFeeInfo={licenseFeeInfo}
          />
        </MidFlowRoute>

        <MidFlowRoute enteredFlow={enteredFlow} path="/contact">
          <TbidContact
            payload={payload}
            ownerFirstName={ownerFirstName}
            ownerLastName={ownerLastName}
            handleNameChange={handleNameChange}
            updatePayload={updatePayload}
            businessInfo={businessInfo}
          />
        </MidFlowRoute>

        <MidFlowRoute enteredFlow={enteredFlow} path="/payment">
          <PaymentForm
            licenseFeeInfo={licenseFeeInfo}
            formValues={payload}
            businessInfo={businessInfo}
            resetFlow={resetFlow}
            setPaymentData={setPaymentData}
          />
        </MidFlowRoute>

        <Route path="/success">
          <Success licenseFeeInfo={licenseFeeInfo} paymentData={paymentData}/>
        </Route>
        <Route render={() => <Redirect to={{ pathname: "/" }} />} />
      </Switch>
    </cs.ViewContainer>
  );
}

export default Routes;
